// DefaultFunctional.jsx
import React from 'react'
import { Search, Sort } from '../../Component/Component'

const DefaultFunctional = ({
    additionalData,
    noneSelectUpdatedPictures,
    dispatchAction,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    productSort,
    get,
    search,
    typeSort,
    sortType,
    sortSearch,
    setSearchMainName,
}) => {
    return (
        <div className="disk">
            <Search
                search={search}
                get={get}
                sortType={sortType}
                sortSearch={sortSearch}
                productSort={productSort}
                pageNumber={pageNumber}
                pageSize={pageSize}
                additionalData={additionalData}
                setSearchMainName={setSearchMainName}
            />

            <Sort
                additionalData={additionalData}
                noneSelectUpdatedPictures={noneSelectUpdatedPictures}
                dispatchAction={dispatchAction}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                pageSize={pageSize}
                productSort={productSort}
                get={get}
                typeSort={typeSort}
            />
        </div>
    )
}

export default DefaultFunctional